import { useMemo } from 'react';
import { useWebsiteV2Feature } from '@shared/hooks/useWebsiteV2Feature';

export type IsWebsiteV2 = Readonly<{
  /** The route's event is on Website V2. False until the flag resolves. */
  isWebsiteV2: boolean;
  isLoading: boolean;
}>;

/**
 * Whether the route's event is on Website V2: its `useWebsiteV2` flag, with no request of its own, so
 * any surface can read it (one with no Apollo client included). The one place outside this folder that
 * may ask; everything else reads the website through the adapters (`useWebsitePagesByRole`,
 * `useWebsitePrivacy`, `useEventWebsiteDesign`, …), which resolve the version through `useWebsiteVersion`.
 */
export const useIsWebsiteV2 = (): IsWebsiteV2 => {
  const { value, isLoading } = useWebsiteV2Feature();
  return useMemo(() => ({ isWebsiteV2: !isLoading && value, isLoading }), [value, isLoading]);
};
